export default "__VITE_ASSET__BcbcLg6B__"